import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
  mobileImageAspectRatio?: string;
}

const useStyles = makeStyles<Props>({
  name: 'HighlightMediaTextFull',
})(({ brandColors, spacing, breakpoints, aspectRatio, typography }, props) => ({
  mediaOverlay: {
    aspectRatio: aspectRatio['16/9'],

    '& iframe': {
      backgroundColor: darkOrLightStyle(props)(
        brandColors.black,
        brandColors.white
      ),
    },
  },
  fullSectionHeader: {
    marginTop: 0,
    paddingTop: spacing(2),
    [breakpoints.up('md')]: {
      paddingTop: spacing(4),
      paddingBottom: spacing(4),
    },
    [breakpoints.up('lg')]: {
      marginTop: typography.pxToRem(-11.5),
      marginBottom: typography.pxToRem(-11.5),
    },
  },
  relativeContainer: {
    position: 'relative',
  },
  innerContent: {
    width: '100%',
    paddingBottom: spacing(5),
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),

    [breakpoints.up('md')]: {
      paddingTop: spacing(5),
    },
  },
  imageInnerContent: {
    position: 'static',

    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['16/9'],
    },
  },
  videoInnerContent: {
    position: 'static',

    [breakpoints.up('md')]: {
      backgroundColor: 'unset',
      position: 'absolute',
      top: 0,
      left: 0,
    },
  },
  artDirectedImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
    aspectRatio: props.mobileImageAspectRatio || aspectRatio['1/1'],

    [breakpoints.up('md')]: {
      position: 'absolute',
      top: 0,
      left: 0,
    },
  },
}));

export default useStyles;
